import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { InsightsButton } from '@bingads-webui/copilot-insights';

import { useGetSummarizeMessage } from './use-get-summarize-message';

export const CopilotSummaryButton = (props) => {
  const {
    campaignName,
    className,
    i18n,
    onRender,
    onClick,
  } = props;

  const getSummarizeMessage = useGetSummarizeMessage(i18n);
  useEffect(() => {
    onRender();
  }, [onRender]);

  const onSummarizeClick = useCallback(() => {
    const localizedMessage = getSummarizeMessage(campaignName);
    const detail = {
      eventType: 'message',
      eventData: {
        message: localizedMessage,
        pluginName: 'Summarize',
      },
      eventSource: 'summarize',
    };

    const toggleCopilotEvent = new CustomEvent('copilotToggleEvent', {
      detail,
      bubbles: true,
      cancelable: true,
      composed: false,
    });

    document.dispatchEvent(toggleCopilotEvent);
    onClick(localizedMessage);
  }, [campaignName, getSummarizeMessage, onClick]);

  return (
    <InsightsButton
      onClick={onSummarizeClick}
      label={i18n.getString(_TL_('Summarize'))}
      className={className}
    />
  );
};

CopilotSummaryButton.propTypes = {
  campaignName: PropTypes.string,
  className: PropTypes.string,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
  onRender: PropTypes.func.isRequired,
};

CopilotSummaryButton.defaultProps = {
  campaignName: undefined,
  className: undefined,
};
